import React from "react";
import { Tabs, Tab, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

interface TabMenuProps {
  selectedTab: string;
  selectedSubcategory: string;
  onSubcategoryChange: (subcategory: string) => void;
}

const contentTabs = {
  privacyPolicy: {
    en: "Privacy Policy (English)",
    fr: "Privacy Policy (French)",
    ar: "Privacy Policy (Arabic)",
  },
  aboutUs: {
    en: "About Us (English)",
    fr: "About Us (French)",
    ar: "About Us (Arabic)",
  },
  contactUs: {
    en: "Contact Us (English)",
    fr: "Contact Us (French)",
    ar: "Contact Us (Arabic)",
  },
  faqs: {
    en: "FAQs (English)",
    fr: "FAQs (French)",
    ar: "FAQs (Arabic)",
  },
  termsAndConditions: {
    en: "Terms and Conditions (English)",
    fr: "Terms and Conditions (French)",
    ar: "Terms and Conditions (Arabic)",
  }
};

const TabMenu: React.FC<TabMenuProps> = ({
  selectedTab,
  selectedSubcategory,
  onSubcategoryChange,
}) => {
  const navigate = useNavigate();

  const handleMainTabChange = (event: React.SyntheticEvent, newValue: string) => {
    const path = `/static-content/${newValue.replace(/([A-Z])/g, '-$1').toLowerCase()}`;
    navigate(path);
  };

  const mainTabs: Array<{ label: string; value: string }> = [
    { label: "Privacy Policy", value: "privacyPolicy" },
    { label: "FAQs", value: "faqs" },
    { label: "About Us", value: "aboutUs" },
    { label: "Terms and Conditions", value: "termsAndConditions" },
    { label: "Contact Us", value: "contactUs" },
  ];
  
  // Fallback to an empty object if selectedTab does not match any key in contentTabs
  const subTabs: Record<string, string> = contentTabs[selectedTab] || {};

  return (
    <Box>
      <Tabs
        value={selectedTab}
        onChange={handleMainTabChange}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        TabIndicatorProps={{
          style: { display: "none" },
        }}
        sx={{
          gap: "12px",
          "& .MuiTabs-scrollButtons": {
            color: "#3BC1CD",
          },
          "& .MuiTabs-scroller": {
            overflow: "auto !important",
            WebkitOverflowScrolling: "touch",
          },
        }}
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "20px",
          width: "100%",
        }}
      >
        {mainTabs.map((tab) => (
          <Tab
            key={tab.value}
            label={tab.label}
            value={tab.value}
            style={{
              backgroundColor: selectedTab === tab.value ? "#3BC1CD" : "#FFF",
              color: selectedTab === tab.value ? "#FFF" : "#000",
              border: "1px solid #C4C4C4",
              borderRadius: "8px",
              fontWeight: "bold",
              textTransform: "none",
              padding: "6px 16px",
              minWidth: "auto",
              marginRight: "12px",
              whiteSpace: "nowrap",
            }}
          />
        ))}
      </Tabs>
      <Tabs
        value={selectedSubcategory}
        onChange={(event, newValue) => onSubcategoryChange(newValue)}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{
          gap: "12px",
          "& .MuiTabs-scrollButtons": {
            color: "#3BC1CD",
          },
          "& .MuiTabs-scroller": {
            overflow: "auto !important",
            WebkitOverflowScrolling: "touch",
          },
        }}
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          width: "100%",
        }}
      >
        {Object.entries(subTabs).map(([key, label]) => (
          <Tab
            key={key}
            label={label}
            value={key}
            style={{
              // backgroundColor: selectedSubcategory === key ? "#3BC1CD" : "#FFF",
              color: "#000",
              // border: "1px solid #C4C4C4",
              // borderRadius: "8px",
              fontWeight: "bold",
              textTransform: "none",
              padding: "6px 16px",
              minWidth: "auto",
              marginRight: "12px",
              whiteSpace: "nowrap",
            }}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default TabMenu;